module.exports = __webpack_public_path__ + "static/img/xcxNew.2c19201.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/xcxNew.jpg
// module id = C3eY
// module chunks = 0